import { useState } from 'react';
import { T } from '../styles/theme';

export function useConfirm() {
  const [state, setState] = useState({ open: false, message: '', resolve: null });

  const confirm = (message) => {
    return new Promise((resolve) => {
      setState({ open: true, message, resolve });
    });
  };

  const handleConfirm = () => {
    state.resolve?.(true);
    setState({ open: false, message: '', resolve: null });
  };

  const handleCancel = () => {
    state.resolve?.(false);
    setState({ open: false, message: '', resolve: null });
  };

  const ConfirmDialog = state.open ? (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(13,11,30,0.95)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 }}>
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 20, padding: 24, maxWidth: 400, width: '100%' }}>
        <p style={{ fontFamily: T.fontBody, fontSize: '0.9rem', color: T.text, marginBottom: 24 }}>{state.message}</p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
          <button onClick={handleCancel} className="btn-secondary">Annulla</button>
          <button onClick={handleConfirm} className="btn-danger">Conferma</button>
        </div>
      </div>
    </div>
  ) : null;

  return { confirm, ConfirmDialog };
}
